function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { BreadcrumbText } from './BreadcrumbText';
import * as Utility from '../utility';
export var BreadcrumbContext = /*#__PURE__*/ React.createContext({});
import { Flex, Icon, icons } from '@tapresearch/ui/components';
var INITIAL_BREADCRUMS = [
    {
        content: /*#__PURE__*/ React.createElement(BreadcrumbText, null, /*#__PURE__*/ React.createElement(Flex, {
            align: "center"
        }, /*#__PURE__*/ React.createElement(Icon, {
            mr: 1,
            boxSize: 5,
            color: "gray.300",
            icon: icons.fi.ChevronLeft
        }), "Return to projects")),
        linkProps: {
            as: Link,
            to: "/"
        }
    }
];
export var BreadcrumbProvider = function(param) {
    var children = param.children;
    var location = useLocation();
    var isProjectsSubRoute = !!Utility.useRouteMatch('/projects/*');
    var _useState = _sliced_to_array(useState([]), 2), breadcrumb = _useState[0], setBreadcrumb = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), altContent = _useState1[0], setAltContent = _useState1[1];
    useEffect(function() {
        if (!isProjectsSubRoute) {
            setBreadcrumb([]);
            setAltContent(null);
        }
    }, [
        isProjectsSubRoute,
        location
    ]);
    return /*#__PURE__*/ React.createElement(BreadcrumbContext.Provider, {
        value: {
            breadcrumb: breadcrumb,
            setBreadcrumb: setBreadcrumb,
            INITIAL_BREADCRUMS: INITIAL_BREADCRUMS,
            altContent: altContent,
            setAltContent: setAltContent
        }
    }, children);
};
